import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from "click-outside-vue3"
import DCompanyAwards from "@components/organisms/DCompanyAwards.vue";
import companyCommon from "@modules/company-common";

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#d-company-awards');
  const app = Vue.createApp(DCompanyAwards, {...mountEl.dataset});
  app.use(vClickOutside);
  app.use(VueAxios, axios);
  app.mount('#d-company-awards');
});

companyCommon()